import axios from 'axios';
/*
import storeMain from '@/store';
import router from '@/router';
*/

export const moduleReporting = {
  state: {
    revenue: [],
    users: [],
    registrations: [],
    playersBalance: {},
    gamesBalance: {},
    providersBalance: {},
    operatorsBalance: {}
  },
  getters: {
  },
  mutations: {
    getRevenue(state,list){
      state.revenue = list
    },
    getUsers(state,list){
      state.users = list;
    },
    getRegistrations(state, list){
      state.registrations = list;
    },
    getGamesBalance(state,list){
      state.gamesBalance = list;
    },
    getProvidersBalance(state,list){
      state.providersBalance = list;
    },
    getPlayersBalance(state,list) {
      state.playersBalance = list;
    },
    getOperatorsBalance(state,list){
      state.operatorsBalance = list;
    }
  },
  actions: {

    async getRevenue({ commit, rootState }, params){
      const config = {
        headers: {Authorization: `bearer ${rootState.login.token}`},
      };
      commit('setWarningTime');
      axios
        .get(`${process.env.VUE_APP_SERVER}/backoffice/reporting/revenue?start=${params.start}&end=${params.end}`, config)
        .then((res) => {
          commit('getRevenue', res.data);
        })
        .catch((error) => {
          console.log(error);
        });
    },

    async getUsersCharts({ commit, rootState }, params){
      const config = {
        headers: {Authorization: `bearer ${rootState.login.token}`},
      };
      commit('setWarningTime');
      axios
        .get(`${process.env.VUE_APP_SERVER}/backoffice/reporting/usersactive?start=${params.start}&end=${params.end}`, config)
        .then((res) => {
          commit('getUsers', res.data);
        })
        .catch((error) => {
          console.log(error);
        });
    },

    async getRegistrations({ commit, rootState }, params){
      const config = {
        headers: {Authorization: `bearer ${rootState.login.token}`},
      };
      commit('setWarningTime');
      axios
        .get(`${process.env.VUE_APP_SERVER}/backoffice/reporting/registrations?start=${params.start}&end=${params.end}`, config)
        .then((res) => {
          commit('getRegistrations', res.data);
        })
        .catch((error) => {
          console.log(error);
        });
    },

    async getPlayersBalance({ commit, rootState }, params){
      const config = {
        headers: {Authorization: `bearer ${rootState.login.token}`},
      };
      commit('setWarningTime');
      axios
        .get(`${process.env.VUE_APP_SERVER}/backoffice/reporting/players/balance?start=${params.start}&end=${params.end}`, config)
        .then((res) => {
          commit('getPlayersBalance', res.data);
        })
        .catch((error) => {
          console.log(error);
        });
    },

    async getGamesBalance({ commit, rootState }, params){
      const config = {
        headers: {Authorization: `bearer ${rootState.login.token}`},
      };
      commit('setWarningTime');
      axios
        .get(`${process.env.VUE_APP_SERVER}/backoffice/reporting/games/balance?start=${params.start}&end=${params.end}`, config)
        .then((res) => {
          commit('getGamesBalance', res.data);
        })
        .catch((error) => {
          console.log(error);
        });
    },

    async getProvidersBalance({ commit, rootState }, params){
      const config = {
        headers: {Authorization: `bearer ${rootState.login.token}`},
      };
      commit('setWarningTime');
      axios
        .get(`${process.env.VUE_APP_SERVER}/backoffice/reporting/providers/balance?start=${params.start}&end=${params.end}`, config)
        .then((res) => {
          commit('getProvidersBalance', res.data);
        })
        .catch((error) => {
          console.log(error);
        });
    },

    async getOperatorsBalance({ commit, rootState }, params){
      const config = {
        headers: {Authorization: `bearer ${rootState.login.token}`},
      };
      commit('setWarningTime');
      axios
        .get(`${process.env.VUE_APP_SERVER}/backoffice/reporting/bookmakers/balance?start=${params.start}&end=${params.end}`, config)
        .then((res) => {
          commit('getOperatorsBalance', res.data);
        })
        .catch((error) => {
          console.log(error);
        });
    },

  }
};
